var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgReload = function SvgReload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 15 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M.594 10.422A6.89 6.89 0 0 0 7.5 17.336a6.884 6.884 0 0 0 6.898-6.914.624.624 0 0 0-.648-.649c-.367 0-.61.274-.61.649a5.627 5.627 0 0 1-5.64 5.656 5.633 5.633 0 0 1-5.648-5.656A5.625 5.625 0 0 1 7.5 4.782c.594 0 1.148.046 1.61.155L6.772 7.25a.65.65 0 0 0-.18.445c0 .36.266.625.618.625a.59.59 0 0 0 .453-.18l3.219-3.234a.61.61 0 0 0 .195-.468.67.67 0 0 0-.195-.47L7.664.704a.58.58 0 0 0-.453-.187c-.352 0-.617.28-.617.64 0 .164.062.32.172.446l2.078 2.054A7 7 0 0 0 7.5 3.523a6.88 6.88 0 0 0-6.906 6.899"
  })));
};
export default SvgReload;